var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebpageApiLightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.00004mm",
    height: "12mm",
    viewBox: "0 0 34.01586 34.01575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #fff;\n      }\n\n      .b {\n        fill: #4b9fd8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.5817,4.61225A2.38719,2.38719,0,0,0,29.18615,7.429L16.78863,19.82655,9.62186,12.65982A2.49159,2.49159,0,1,0,7.609,14.67264l8.17318,8.17314a1.42291,1.42291,0,0,0,2.01282,0L31.19885,9.442a2.43034,2.43034,0,1,0,.38285-4.82971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.5817,13.14449a2.42905,2.42905,0,0,0-1.4237,4.4008V29.49277a1.678,1.678,0,0,1-1.67611,1.67612H4.523a1.678,1.678,0,0,1-1.67611-1.67612V5.53355A1.678,1.678,0,0,1,4.523,3.85744H23.81183a2.43424,2.43424,0,1,0,.00031-2.84686H4.523A4.52794,4.52794,0,0,0,0,5.53355V29.49277a4.528,4.528,0,0,0,4.523,4.523H28.48189a4.528,4.528,0,0,0,4.523-4.523v-11.947a2.42908,2.42908,0,0,0-1.42316-4.40126Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpageApiLightSmall);
export default __webpack_public_path__ + "static/media/webpage-api_light_small.c7162c1db8d7945a30b7eb0e1f95ba2a.svg";
export { ForwardRef as ReactComponent };